/* NW sengeguide: bundbjaelken. Ombygget 31-08-2026 efter Mads' UX-gennemgang.

   PROBLEMER DEN LOESER:
   1) BJAELKEN KENDTE IKKE RABATTEN. Guiden viste 1.777 kr hvor kunden betalte
      1.660,30 kr. Rabatten der beloenner praecis det guiden forsoeger at faa kunden
      til, var usynlig i det sekund kunden beslutter sig.
   2) INTET BILLEDE. Sitets egen sticky-atc.liquid har foto, titel, variant, knap.
   3) TRUST-TEKSTEN LAA PAA DEN BEDSTE PLADS, lige til venstre for koebsknappen,
      selv om samme tekst staar i toppen af siden. Fjernet fra markup'en.
   4) BJAELKEN VOKSEDE PAA MOBIL naar man tilfoejede et tilvalg, saa layoutet hoppede
      under fingeren praecis mens man trykkede. Og metalinjen blev klippet, saa
      besparelsen, altsaa hele pointen, stod som "du sparer ...". Meldt af Mads 31/8.

   SAADAN ER 4 LOEST:
   Metalinjen er ALTID til stede med reserveret hoejde, ogsaa naar den er tom, saa
   bjaelken har samme hoejde uanset hvad kunden vaelger. Og paa smalle skaerme skrives
   der kortere tekst: titlen uden materialenavnet, som fotoet og overskriften lige
   ovenfor i forvejen fortaeller, og "Spar X kr." i stedet for "N dele . du sparer X kr.".
   Saa er der plads, og intet klippes.

   HVORDAN RABATTEN REGNES, og hvorfor konservativt:
   Shopify-automatrabatter oprettet 31/8: 15% paa op til 3 enheder fra Lagner,
   Pudebetraek og Dyner, udloest af de 23 produkter med taget komplet-saet.
   Vi taeller KUN lagen, pudebetraek og dyne. Hovedpuden udelades, hoer og silke faar
   ingen rabat vist, og besparelsen rundes NED. Under-lov, aldrig over-lov.

   FEJL RETTET UNDER TEST: foerste version cachede listeprisen og regnede rabatten ud
   fra det gamle grundlag naar kunden tilfoejede mere. Vi husker nu ogsaa hvad VI sidst
   skrev, saa vi kan se forskel paa vores eget tal og et friskt tal fra guiden.

   AENDRES RABATTEN I SHOPIFY, skal SATS og MATERIALER herunder rettes med. */
(function(){
  'use strict';

  var SATS = 0.15;
  var MATERIALER = { bambus: true, egyptisk: true };
  var MAX_ENHEDER = 3;
  var SMAL = 620;

  var hooket = false, barObs = false;

  function smal(){ return window.innerWidth <= SMAL; }
  function kr(n){ return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function tal(s){ return Number(String(s).replace(/\./g, '').replace(/[^0-9]/g, '')) || 0; }

  function lagenPris(){
    try{
      if(!chosen.lagen || !chosen.lagen.on){ return 0; }
      var typ = (chosen.lagen.type === 'kuvert') ? 'kuvert' : 'box';
      for(var i = 0; i < lagenSizes.length; i++){
        if(lagenSizes[i].v === chosen.lagen.size){ return lagenSizes[i][typ] || 0; }
      }
    }catch(e){}
    return 0;
  }

  function pbPris(){
    try{
      if(!chosen.pb || !chosen.pb.qty){ return 0; }
      for(var i = 0; i < pbSizes.length; i++){
        if(pbSizes[i].v === chosen.pb.size){ return pbSizes[i].price || 0; }
      }
    }catch(e){}
    return 0;
  }

  function dynePris(){
    try{
      if(!chosen.dyne || !chosen.dyne.on){ return 0; }
      var d = dyneSizeData(dyneOpt(chosen.dyne.opt), chosen.size);
      return d ? (d.price || 0) : 0;
    }catch(e){}
    return 0;
  }

  function enheder(){
    var ud = [], i;
    var lp = lagenPris();
    if(lp){ for(i = 0; i < (chosen.lagen.qty || 1); i++){ ud.push(lp); } }
    var pp = pbPris();
    if(pp){ for(i = 0; i < (chosen.pb.qty || 0); i++){ ud.push(pp); } }
    var dp = dynePris();
    if(dp){ ud.push(dp); }
    return ud;
  }

  function besparelse(){
    try{
      if(!MATERIALER[chosen.mat]){ return 0; }
      var e = enheder();
      if(!e.length){ return 0; }
      e.sort(function(a, b){ return b - a; });
      var sum = 0;
      for(var i = 0; i < e.length && i < MAX_ENHEDER; i++){ sum += e[i]; }
      return Math.floor(sum * SATS);
    }catch(e){ return 0; }
  }

  function antalDele(){
    var n = 1;
    try{
      if(chosen.lagen && chosen.lagen.on){ n += (chosen.lagen.qty || 1); }
      if(chosen.pb && chosen.pb.qty){ n += chosen.pb.qty; }
      if(chosen.pude && chosen.pude.qty){ n += chosen.pude.qty; }
      if(chosen.dyne && chosen.dyne.on){ n += 1; }
      if(chosen.simple){
        if(chosen.simple.vaskemiddel){ n += 1; }
        if(chosen.simple.vaskepose){ n += 1; }
      }
    }catch(e){}
    return n;
  }

  function tegn(){
    try{
      if(typeof chosen === 'undefined' || !chosen || !chosen.mat){ return; }

      var thumb = document.getElementById('bthumb');
      var rimg = document.getElementById('rimg');
      if(thumb && rimg && rimg.src && thumb.src !== rimg.src){
        thumb.src = rimg.src;
        thumb.alt = '';
        thumb.hidden = false;
      }

      /* Titel: fjern altid guidens tekniske "+ N tilvalg". Paa smalle skaerme ogsaa
         materialenavnet, som fotoet og overskriften lige ovenfor allerede fortaeller. */
      var titel = document.getElementById('bartitle');
      if(titel){
        var t = titel.textContent;
        var m = t.match(/^(.*?)\s*\+\s*\d+\s*tilvalg\s*$/);
        if(m){ t = m[1].trim(); }
        if(smal()){
          /* Fjern KUN materialenavnet, og kun hvis det staar der. Uden denne test
             koerte stripningen igen paa sit eget resultat, saa ogsaa farven forsvandt
             og der stod bare "140x200". Fanget i test 31/8. */
          var matNavn = '';
          try{ matNavn = (materials[chosen.mat].name || '').trim(); }catch(e){}
          var d = t.split(' · ');
          if(matNavn && d.length > 1 && d[0].trim() === matNavn){
            t = d.slice(1).join(' · ');
          }
        }
        if(titel.textContent !== t){ titel.textContent = t; }
      }

      var total = document.getElementById('bartotal');
      var was = document.getElementById('barwas');
      var meta = document.getElementById('barmeta');
      if(!total || !was){ return; }

      var liste;
      if(was.dataset.mit && total.textContent === was.dataset.mit && was.dataset.liste){
        liste = Number(was.dataset.liste);
      } else {
        liste = tal(total.textContent);
      }
      if(!liste){ return; }

      var spar = besparelse();
      var dele = antalDele();

      if(spar > 0 && spar < liste){
        var nyTotal = kr(liste - spar);
        was.dataset.liste = String(liste);
        was.dataset.mit = nyTotal;
        if(total.textContent !== nyTotal){ total.textContent = nyTotal; }
        var nyWas = kr(liste) + ' kr.';
        if(was.textContent !== nyWas){ was.textContent = nyWas; }
        if(meta){
          var mt = smal()
            ? 'Spar ' + kr(spar) + ' kr.'
            : (dele === 1 ? '1 del' : dele + ' dele') + ' · du sparer ' + kr(spar) + ' kr.';
          if(meta.textContent !== mt){ meta.textContent = mt; }
          meta.classList.add('bmeta--spar');
        }
      } else {
        if(was.textContent !== ''){ was.textContent = ''; }
        delete was.dataset.liste;
        delete was.dataset.mit;
        if(meta){
          /* Tom, men linjen bliver staaende, saa bjaelken ikke skifter hoejde. */
          var mt2 = (!smal() && dele > 1) ? (dele + ' dele') : '';
          if(meta.textContent !== mt2){ meta.textContent = mt2; }
          meta.classList.remove('bmeta--spar');
        }
      }
    }catch(e){}
  }

  function stil(){
    if(document.getElementById('nw-sg-bar-css')){ return; }
    var s = document.createElement('style');
    s.id = 'nw-sg-bar-css';
    s.textContent =
      '#nwsg .bar .bleft{display:flex;align-items:center;gap:12px;min-width:0}' +
      '#nwsg .bar .bthumb{width:46px;height:46px;object-fit:cover;border-radius:4px;border:1px solid var(--line);flex-shrink:0;background:#fff}' +
      '#nwsg .bar .binfo{min-width:0}' +
      '#nwsg .bar .bt{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      /* Reserveret hoejde, ogsaa naar linjen er tom. Saa hopper bjaelken ikke naar
         kunden tilfoejer et tilvalg. */
      '#nwsg .bar .bmeta{font-size:11.5px;color:var(--stone);line-height:1.4;margin-top:1px;min-height:1.4em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '#nwsg .bar .bmeta--spar{color:var(--sageDark);font-weight:500}' +
      '#nwsg .bar .bprices{display:flex;flex-direction:column;align-items:flex-end;line-height:1}' +
      '#nwsg .bar .bwas{font-size:12px;color:var(--stone);text-decoration:line-through;min-height:1.2em}' +
      '#nwsg .nw-sg-fav-row{max-width:1240px;margin:0 auto;padding:0 24px 10px;justify-content:flex-end}' +
      '@media(max-width:768px){#nwsg .nw-sg-fav-row{padding:0 18px 9px;justify-content:center}}' +
      '@media(max-width:620px){' +
        '#nwsg .bar .bthumb{width:38px;height:38px}' +
        '#nwsg .bar .bt{font-size:11.5px}' +
        '#nwsg .bar .bmeta{font-size:10.5px}' +
        '#nwsg .bar .bwas{font-size:11px}' +
      '}';
    document.head.appendChild(s);
  }

  function hookBar(){
    if(barObs){ return; }
    var bar = document.getElementById('bar');
    if(!bar){ return; }
    barObs = true;
    try{
      new MutationObserver(function(){ tegn(); }).observe(bar, { childList: true, subtree: true, characterData: true });
    }catch(e){}
  }

  function kobl(){ stil(); hookBar(); tegn(); }

  function hook(){
    if(hooket || typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    var f = window.renderResult;
    window.renderResult = function(){
      var r = f.apply(this, arguments);
      tegn();
      return r;
    };
  }

  kobl(); hook();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ kobl(); hook(); }); }
  window.addEventListener('load', function(){ kobl(); hook(); });
  window.addEventListener('resize', function(){ tegn(); });
  setTimeout(function(){ kobl(); hook(); }, 1500);
  setTimeout(function(){ kobl(); hook(); }, 3500);
})();